import { render, staticRenderFns } from "./ModalDuplicarCardapioPDV.vue?vue&type=template&id=be515788&scoped=true&"
import script from "./ModalDuplicarCardapioPDV.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicarCardapioPDV.vue?vue&type=script&lang=js&"
import style0 from "./ModalDuplicarCardapioPDV.vue?vue&type=style&index=0&id=be515788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be515788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VFlex,VIcon,VSelect,VToolbar})
